export default {
  name: 'localeMixin',
  data () {
    return {
      params: {
        code: this.$route.params.code,
        locale: this.$route.params.locale
      },
      query: {
        email: this.$route.query.email,
        first_name: this.$route.query.first_name,
        last_name: this.$route.query.last_name,
        phone: this.$route.query.phone
      }
    }
  },
  methods: {
    switchLocale (locale) {
      if (locale) {
        this.params.locale = locale
      } else {
        this.params.locale === 'en' || this.params.locale === undefined ? this.params.locale = 'es' : this.params.locale = 'en'
      }
      this.$router.replace({ params: this.params, query: this.query })
      this.$router.go()
    }
  }
}
